/**
 * @desc 分箱临时接口
 */
const URL = "/rantion-wms";
import http, { updateResponse } from "@/http";
export function request(aono: string | number, options?: any) {
  return updateResponse(
    http(URL + `/allocationBox/temp/${aono}`, {
      method: "GET",

      ...options,
    }),
  );
}
